/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import * as z from "zod";

export const getNumberValidator = (validator: any) => {
  let newz = z?.coerce.number();
  if (validator) {
    validator.forEach((rule: any) => {
      if (!rule) return;

      if (rule.rule === "range") {
        const minValue = (
          rule.condition.split(",")[0] as unknown as string
        ).replace(/\D/g, "") as unknown as string;

        const maxValue = (
          rule.condition.split(",")[1] as unknown as string
        ).replace(/\D/g, "") as unknown as string;

        newz = newz.gte(
          +minValue,
         rule?.message ?? "The minimum value of input can be " + minValue
        );
        newz = newz.lte(
          +maxValue,
          rule?.message ?? "The maximum value of input can be " + maxValue
        );
      }
    });
  }
  return newz;
};
